import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const DetectionType = iotsUtils.fromList(constants.ai.detection.ids);

export const DoorType = iotsUtils.fromList(constants.ai.detection.doorTypeIds);

export const PageType = iotsUtils.fromList(constants.ai.detection.pageTypeIds);
